<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.orders.manual_checks.name')"
            is-required
            :error="errors.name"
            :hint="__('settings.orders.manual_checks.name_hint_check')"
        >
            <DFormTextarea
                id="name"
                v-model="form.name"
                :placeholder="__('settings.orders.manual_checks.name')"
                class="mb-0"
                rows="3"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.orders.manual_checks.order_manual_check_group_setting_id')"
            is-required
            :error="errors.order_manual_check_group_setting_id"
            :hint="__('settings.orders.manual_checks.order_manual_check_group_setting_id_hint')"
        >
            <DSelect
                id="order_manual_check_group_setting_id"
                v-model="form.order_manual_check_group_setting_id"
                :options="manualCheckGroups"
                :placeholder="__('settings.orders.manual_checks.order_manual_check_group_setting_id')"
                :is-valid="isFormFieldValid('order_manual_check_group_setting_id')"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.orders.manual_checks.text')"
            :error="errors.text"
            :hint="__('settings.orders.manual_checks.text_hint')"
        >
            <DFormTextarea
                id="text"
                v-model="form.text"
                :placeholder="__('settings.orders.manual_checks.text')"
                class="mb-0"
                rows="3"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.orders.manual_checks.solution_instruction')"
            :error="errors.solution_instruction"
            :hint="__('settings.orders.manual_checks.solution_instruction_hint')"
        >
            <DFormTextarea
                id="solution_instruction"
                v-model="form.solution_instruction"
                :placeholder="__('settings.orders.manual_checks.solution_instruction')"
                class="mb-0"
                rows="3"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.orders.manual_checks.tool_tip')"
            :error="errors.tool_tip"
            :hint="__('settings.orders.manual_checks.tool_tip_hint')"
        >
            <DFormTextarea
                id="tool_tip"
                v-model="form.tool_tip"
                :placeholder="__('settings.orders.manual_checks.tool_tip')"
                class="mb-0"
                rows="3"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.orders.manual_checks.external')"
            :error="errors.external"
            :hint="__('settings.orders.manual_checks.external_hint')"
        >
            <DSwitch
                id="switch-external"
                v-model="form.external"
                color="success"
                variant="3d"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.orders.manual_checks.active')"
            :error="errors.active"
            :hint="__('settings.orders.manual_checks.active_hint_check')"
        >
            <DSwitch
                id="switch-active"
                v-model="form.active"
                color="success"
                variant="3d"
            />
        </DFormRow>
        <DFormControls
            :cancel-route="cancelRoute"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>

export default {
    name: 'OrderManualCheckSettingsForm',
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        manualCheck: {
            type: Object,
            default: () => { return {} }
        },
        manualCheckGroups: {
            type: Array,
            default: () => { return [] }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                order_manual_check_group_setting_id: this.manualCheck?.order_manual_check_group_setting_id ?? null,
                name: this.manualCheck?.name ?? null,
                text: this.manualCheck?.text ?? null,
                solution_instruction: this.manualCheck?.solution_instruction ?? null,
                tool_tip: this.manualCheck?.tool_tip ?? null,
                external: this.manualCheck?.external ?? false,
                active: this.manualCheck?.active ?? true
            })
        }
    },
    computed: {
        cancelRoute () {
            return this.$route('settings.order-manual-check-group-settings.index')
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        }
    }
}
</script>
